/** @file Converts the legacy timeline-comment mutation response to the conversation comments API format. */

import type {ConversationIssueComment} from '../page-data/payloads/conversation-comments'
import type {IssueComment} from '../page-data/payloads/issue-comments'

/**
 * Fields the conversation comments API provides but the legacy timeline-comment mutation response does not.
 */
const missingFields = {
  bodyVersion: '',
  lastUserContentEdit: null,
  relayId: '',
  stafftoolsUrl: null,
  viewerCanDelete: false,
  viewerCanMinimize: false,
  viewerCanSeeMinimizeButton: false,
  viewerCanSeeUnminimizeButton: false,
  viewerCanUpdate: false,
  viewerDidAuthor: false,
} as const

/**
 * Temporary shim mapping the legacy issue comments payload onto the conversation comments model.
 * @deprecated use conversation comments models directly
 */
export function buildConversationIssueComment(comment: IssueComment): ConversationIssueComment {
  return {
    ...missingFields,
    type: 'issue',
    id: Number(comment.id),
    author: {login: comment.authorLogin, avatarUrl: comment.authorAvatarUrl ?? '', isAgent: comment.isAgent ?? false},
    authorAssociation: comment.authorAssociation,
    body: comment.body,
    bodyHTML: comment.bodyHtml,
    createdAt: comment.createdAt,
    publishedAt: comment.publishedAt,
    isHidden: comment.isHidden,
    minimizedReason: comment.minimizedReason,
    reactionGroups: comment.reactionGroups,
    relayId: comment.relayId,
    viewerCanBlockFromOrg: comment.viewerCanBlockFromOrg,
    viewerCanBlockPersonally: comment.viewerCanBlockPersonally,
    viewerCanReact: comment.viewerCanReact,
    viewerCanUnblockFromOrg: comment.viewerCanUnblockFromOrg,
    viewerCanUnblockPersonally: comment.viewerCanUnblockPersonally,
    repository: comment.repository,
    url: comment.url,
  }
}
